import { useEffect, useState } from 'react'
import Clock from 'react-clock'
import 'react-clock/dist/Clock.css'
import uploadingWait from '../../images/uploading-wait.jpg'

export default function UploadingWait() {
    const [value, setValue] = useState(new Date())
    const [portrait, setIsPortrait] = useState(window.innerWidth > window.innerHeight ? false : true)

    useEffect(() => {
        const interval = setInterval(() => setValue(new Date()), 1000)
        const handleOrientationChange = () => {
            setIsPortrait(window.screen.orientation.type.startsWith('portrait'))
        }

        window.screen.orientation.addEventListener('change', handleOrientationChange)
        return () => {
            clearInterval(interval)
            window.screen.orientation.removeEventListener('change', handleOrientationChange)
        }
    }, [])

    return (
        <div style={{
            backgroundImage: `url(${uploadingWait})`,
            backgroundSize: portrait ? 'cover' : 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 1,
            display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh',
            backgroundColor: 'lightblue', justifyContent: 'center', alignItems: 'center',
            paddingLeft: '10vw', paddingRight: '10vw'

        }}>
            <div style={{
                display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh',
                justifyContent: 'flex-start', alignItems: 'center',
                paddingLeft: '10vw', paddingRight: '10vw'
            }}>

                <h4 style={{ textAlign: 'center', color: 'white' }}>Uploading. Please wait and do *not* leave this screen</h4>
                <div className="Sample__container">
                    <main className="Sample__container__content">
                        <Clock size={portrait ? 200 : 150} value={value} />
                    </main>
                </div>
            </div>
        </div>
    )
}